import React from 'react'
import community from '../../img/community.png'
import BookButton from '../Shared/BookButton'

export default function Community() {
    return (
        <div className='grid md:grid-cols-2 grid-cols-1' >
            <div className='py-20 px-5 m-5'>
                <h1 className='text-4xl font-bold my-5'>We are the <span className='text-red-500'>Community</span> of
                    <span className='text-blue-500'> top Mentors</span> and <span className='text-red-500'>Counsellors</span></h1>
                <h3 className='text-2xl font-medium'>Our mission is to improve the lives of students by
                    offering them the greatest career guidance and
                    recommendations.</h3>
                <div>
                    <BookButton name='Join Now!' />
                </div>

            </div>
            <div className='py-10 m-5'>
                <img src={community} />
            </div>

        </div>

    )
}       